import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TableWrapper = styled(Grid)((props: { isMobile?: boolean }) => `
  overflow: ${props.isMobile ? 'visible' : 'auto'};
  width: 100%;
  height: 'auto';
  ${!props.isMobile && 'max-height: calc(100vh - 278px);'}

  ${props.isMobile ? `
    /* Allow the MUI DataGrid to grow to content height on mobile (no internal scroll) */
    .MuiDataGrid-root {
      height: auto !important;
      min-height: 0;
      border: none;
    }
    .MuiDataGrid-viewport,
    .MuiDataGrid-row,
    .MuiDataGrid-renderingZone {
      max-height: fit-content !important;
    }
    .MuiDataGrid-cell {
      overflow: visible;
      white-space: normal !important;
    }
    .MuiDataGrid-columnHeaderTitle {
      display: none !important;
    }
    .MuiDataGrid-columnHeaders {
      visibility: hidden !important;
    }
  ` : ''}
`);